import { render, staticRenderFns } from "./SaleBrandsAll.vue?vue&type=template&id=38ff3062&scoped=true&"
import script from "./SaleBrandsAll.vue?vue&type=script&lang=js&"
export * from "./SaleBrandsAll.vue?vue&type=script&lang=js&"
import style0 from "./SaleBrandsAll.vue?vue&type=style&index=0&id=38ff3062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff3062",
  null
  
)

export default component.exports